import { render, staticRenderFns } from "./LeftItem.vue?vue&type=template&id=8cb9fa42"
import script from "./LeftItem.vue?vue&type=script&lang=js"
export * from "./LeftItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports